import { mapState, mapActions } from 'vuex';
import i18n from '../../i18n/index';
import configRoutes from '../../utils/routerUtils';

export default {
  data() {
    return {
      valid: false,
      username: '',
      password: '',
      rules: {
        required: value => !!value || i18n.t('field-required')
      },
      paths: []
    };
  },
  computed: {
    ...mapState('auth', ['status'])
  },
  methods: {
    ...mapActions('auth', ['login']),
    submit() {
      if (this.$refs.form.validate()) {
        const { username, password } = this;
        this.login({ username, password })
          .then(user => {
            configRoutes(this.$router);
            this.$router.push('/');
          }).catch(error => {
            if (error && error.error === 'Invalid credentials') {
              this.$notify({
                group: "app",
                type: "error",
                text: i18n.t('login.invalid-credentials')
              });
              return;
            }

            this.$notify({
              group: "app",
              type: "error",
              text: i18n.t('login.error-occurred')
            });
          });
      }
    }
  }
};
